export default function Pain() {
  return (
    <section className="mx-auto max-w-160 px-6 pt-20 pb-8 text-center sm:pt-24 sm:pb-10">
      <p className="text-lg leading-relaxed text-foreground/80 sm:text-xl">
        AI is powerful but unpredictable.
        <br />
        Getting it to behave consistently, at scale, is real work.
      </p>
    </section>
  )
}
